<label class="ms-1" [ngClass]="[bold ? 'bold' : '', labelClass]" [for]="for">
  <ng-content></ng-content>
  <ng-container *ngIf="appendColon">:</ng-container>
</label>
